import {
  type ClientOptions,
  createRpcClient,
  type InferRpcClient,
} from "@redotech/rpc/client";
import { rpcDefinition } from "./definition";

export function createRedoDnsRpcClient(
  options: ClientOptions<typeof rpcDefinition>,
): InferRpcClient<typeof rpcDefinition> {
  return createRpcClient(rpcDefinition, options);
}

export type RedoDnsRpcClient = ReturnType<typeof createRedoDnsRpcClient>;
